export const Role = {
    SuperAdmin: 'Super admin',
    Admin: 'Admin',
    Merchant: 'Merchant'    
}